export const DOCUMENTATION_BAR_CLOSED = "documentationBarClosed";
export const HIDE_IGNORED_RUN_NOTICE_LOCAL_STORAGE_KEY = "hideIgnoredRunNotice";
